import {Component, OnInit} from "@angular/core";
import {CoreService} from "../../common/core.service";
import {FormsModule} from "@angular/forms";
import {TranslateModule, TranslateService} from "@ngx-translate/core";
import {CommonModule, NgOptimizedImage} from "@angular/common";
import {Title} from "@angular/platform-browser";
import ICreatePasswordViewData = NCVIB.app.login.CreatePassword.ICreatePasswordViewData;
import {RouterLink} from "@angular/router";
import IForgotPasswordCommand = NCVIB.app.login.ForgotPassword.Commands.IForgotPasswordCommand;
import {TrackingTranslateService} from "../../common/translation/tracking-translate.service";

@Component({
    templateUrl: './forgot-password.component.html',
    imports: [
        FormsModule,
        CommonModule,
        TranslateModule,
        RouterLink
    ],
    standalone: true,
    styleUrls: ['./forgot-password.component.css']
})
export class ForgotPasswordComponent implements OnInit {
    email: string | null = null;
    userName: string | null = null;
    userNameIsUnknown: boolean = false;
    passwordChanged: boolean = false;
    viewData: ICreatePasswordViewData | undefined;
    errorMessage: string = "";

    constructor(
        private title: Title,
        private core: CoreService,
        private translationService: TrackingTranslateService
    ) {
        this.title.setTitle(`NCVIB - ${this.translationService.instant("ForgotPassword")}`);
    }

    ngOnInit() {
        this.loadViewData();
    }

    private loadViewData() {
        this.core.get<ICreatePasswordViewData>(`api/forgot-password/load-view-data`, "Load forgot password", true)
            .subscribe({
                next: (viewData: ICreatePasswordViewData) => {
                    this.viewData = viewData;
                },
                error: (error: unknown) => {
                    this.errorMessage = String(error);
                }
            });
    }

    public sendEmail() {
        if (this.userNameIsUnknown) {
            this.userName = null;
        } else {
            this.email = null;
        }

        if (this.userName == null && this.email == null) {
            return;
        }

        const command: IForgotPasswordCommand = {
            email: this.email ?? undefined,
            username: this.userName ?? undefined
        };

        this.core.post(`api/forgot-password/send-reset-link`, command, "Send reset link to user", true)
            .subscribe({
                next: () => {
                    this.passwordChanged = true;
                },
                error: (error: unknown) => {
                    this.errorMessage = String(error);
                }
            });
    }

    public userNameIsUnknownLabel(): string {
        return this.userNameIsUnknown ? "IDontKnowMyEmail" : "IDontKnowMyUsername";
    }
}
